import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import useProduct from "@/hooks/useProduct";
import { useTranslation } from "react-i18next";
import Contents from "@/components/main/Contents";

const Wrap = styled.div``;

const Section = styled.div`
  margin: 40px auto;
  padding: 60px 120px;
  width: calc(100% - 100px);
  background-color: #fff;
  border-radius: 20px;

  @media (max-width: 1200px) {
    width: calc(100% - 40px);
    padding: 50px 40px;
  }

  @media (max-width: 800px) {
    width: calc(100% - 40px);
    padding: 30px 20px;
  }
`;
const SectionSubTitle = styled.p`
  font-family: "Hind";
  font-size: 28px;
  color: #000;
`;
const SectionTitle = styled.p`
  margin: 10px 0 20px 0;
  font-family: "Lato Bold", sans-serif;
  font-size: 44px;
  font-weight: 600;
  color: #971b2f;
`;

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 -10px;
  width: calc(100% + 20px);
`;
const Item = styled.div`
  margin: 0 10px 20px 10px;
  width: calc(25% - 20px);
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.04) 0 1px 0, rgba(0, 0, 0, 0.05) 0 2px 7px, rgba(0, 0, 0, 0.06) 0 12px 22px;
  cursor: pointer;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: calc(33% - 20px);
  }

  @media (max-width: 1000px) {
    width: calc(50% - 20px);
  }

  @media (max-width: 800px) {
    width: calc(100% - 20px);
  }
`;
const ItemImg = styled.img`
  width: 100%;
`;
const ItemContent = styled.div`
  padding: 18px 24px 24px 24px;
`;
const ItemTitle = styled(SectionTitle)`
  margin: 0 0 15px 0;
  font-size: 32px;
  color: #444;
`;
const ItemDesc = styled(SectionSubTitle)`
  line-height: 26px;
  font-size: 16px;
  color: #676767;
`;

export default function Page() {
  const { t } = useTranslation();
  const product = useProduct();

  useEffect(() => {
    product.fetchProductsAsync();
  }, []);

  if (product.state.loading) {
    return <>loading...</>;
  }

  if (product.state.products.length < 1) {
    return <>Products not found.</>;
  }

  const products = [
    { title: t("menu.products.body-composition-analyzers"), products: product.state.products.slice(0, 5) },
    { title: t("menu.products.body-water-analyzers"), products: product.state.products.slice(5, 7) },
    { title: t("menu.products.blood-pressure-monitor"), products: product.state.products.slice(9, 11) },
    { title: t("menu.products.stadiometer"), products: product.state.products.slice(7, 9) },
    { title: t("menu.products.handgrip-strength-dynamometer"), products: product.state.products.slice(11, 12) },
  ];

  return (
    <>
      <Header />
      <Wrap>
        {products.map((v) => (
          <Section key={v.title}>
            <SectionSubTitle data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="100" data-aos-duration="500">
              {t("menu.support.brochure-downloads.brochure-download")}
            </SectionSubTitle>
            <SectionTitle data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="200" data-aos-duration="500">
              {v.title}
            </SectionTitle>
            <Items>
              {v.products.map((vv) => (
                <Item key={vv.id}>
                  <ItemImg src={vv.brochureImage} />
                  <ItemContent>
                    <ItemTitle>{t(vv.title)}</ItemTitle>
                    <ItemDesc>{t(vv.brochureDesc)}</ItemDesc>
                  </ItemContent>
                </Item>
              ))}
            </Items>
          </Section>
        ))}
      </Wrap>
      <Contents
        title={t("menu.support.contact-us")}
        desc={t("main.contents.lets-get-in-touch.desc")}
        link={"/contact/contact-us/"}
      />
      <Footer />
    </>
  );
}
